<template>
    <div>
        <b-collapse v-for="question in this.questions" :key="question.id" class="colap-barra mb-4"
            animation="slide" :aria-id="'collapse' + question.id" :open="isQuestionOpen(question.id)" :id="`q${question.id}`">
            <template slot="trigger" slot-scope="props">
                <button :class="props.open ? 'colap-button-down' : 'colap-button'" role="button"
                    :aria-controls="'collapse' + question.id">
                    <h2 class="colap-header">
                        <a :href="getQuestionUrl(question.id)" class="has-text-black">{{ question.question }}</a>
                    </h2>
                    <span class="card-header-icon">
                        <b-icon :icon="props.open ? 'menu-down' : 'menu-up'"
                            aria-hidden="true"></b-icon>
                    </span>
                </button>
            </template>

            <div class="colap-cont">
                <div v-html="question.answer" class="mb-4"></div>
                <p>Actualizado el {{ dateExist(question) }}</p>
            </div>
        </b-collapse>
    </div>
</template>

<script>
export default {
    name: "PreguntasFrecuentesContent",
    props: ['questions', 'topic_id'],
    methods: {
        formatDate: function (date) {
            return moment(date).format("DD") + ' de ' + moment(date).format("MMMM") + ' de ' + moment(date).format("YYYY") + ' a las ' + moment(date).format("HH:mm") + ' horas.';
        },
        dateExist: function (question) {
            if (question.updated_at) {
                return this.formatDate(question.updated_at);
            } else {
                return this.formatDate(question.created_at);
            }
        },
        isQuestionOpen(questionId) {
            const hash = window.location.hash;
            return hash === `#q${questionId}`;
        },
        getQuestionUrl(questionId) {
            const url = new URL(window.location.href);
            url.hash = `q${questionId}`;
            return url.toString();
        }
    },
    mounted() {
        // Si hay un hash en la URL, hacer scroll a la pregunta
        if (window.location.hash) {
            const element = document.querySelector(window.location.hash);
            if (element) {
                setTimeout(() => {
                    element.scrollIntoView({ behavior: 'smooth' });
                }, 100);
            }
        }
    }
}
</script>